import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../../common/PageTrackerHelper'
import { BasicSelect } from 'vue-search-select';

export default {
  name: 'MarkLostShipment',
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect,
  },
  mixins: [PageTracker],
  data: function () {
    return {
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      isShowing: false,
      listtype: 'ServiceCenter',
      clientid: 0,
      hubzone: 0,
      hubname: 0,
      notifystatus: 'Pending',
      amount: 0,
      amountcomparator: '',
      netpaymnet: '',
      gapdays: 0,
      gapdayscomparator: '',
      txtgapdays: '',
      clientList: [],
      lostReasonsList: [],
      subLostReasonsList: [],
      hubZoneList: [],
      hubServiceCenterList: [],
      shipmentList: [],
      shipmentListCSV: [],
      pageno: 1,
      pagecount: 0,
      shipmentlogmodal: false,
      isLoading: false,
      ddlLostReasons: '',
      ddlSubLostReason: '',
      clientItemObj: { value: '', text: '' },
      optionsData: {
        "Lost_By_SR": [
          { "ReasonId": 8, "Reason": "Lost On Field" },
          { "ReasonId": 9, "Reason": "Manipulatation/Tampering by SR" },
          { "ReasonId": 10, "Reason": "Wrong Delivery" },
          { "ReasonId": 11, "Reason": "Theft By SR" },
          { "ReasonId": 12, "Reason": "Manual Delivery" },
        ],
        "Lost_By_Staff": [
          { "ReasonId": 13, "Reason": "Bagging/Debagging  Process Failure" },
          { "ReasonId": 14, "Reason": "Manipulatation/Tampering by Staff" },
          { "ReasonId": 15, "Reason": "Process Neglience" },
          { "ReasonId": 16, "Reason": "Theft By SR" },
          { "ReasonId": 17, "Reason": "Untraceble In Branch" },
        ],
        "Lost_By_Delivery_Agent": [
          { "ReasonId": 18, "Reason": "Lost By Agent/SR/Staff" },
          { "ReasonId": 19, "Reason": "Manipulatation/Tampering by Staff" },
          { "ReasonId": 20, "Reason": "Manual Delivery" },
          { "ReasonId": 21, "Reason": "Theft By SR/Staff" },
          { "ReasonId": 22, "Reason": "Wrong Delivery" },
        ],
        "Dispute_Client_Consignee": [
          { "ReasonId": 23, "Reason": "Damaged In Intransit" },
          { "ReasonId": 24, "Reason": "Intact Shipment Rejected By Client" },
          { "ReasonId": 25, "Reason": "Product Mismatch" },
          { "ReasonId": 26, "Reason": "Product Missing" },
          { "ReasonId": 27, "Reason": "Product Quality Issue" },
          { "ReasonId": 28, "Reason": "Shipment Weight Dispute" },
          { "ReasonId": 29, "Reason": "Snatched By Consignee" },
          { "ReasonId": 30, "Reason": "Product Quantity Issue" },
        ],
        "Lost_by_coloader": [
          { "ReasonId": 31, "Reason": "Damaged In Intransit" },
          { "ReasonId": 32, "Reason": "Lost Intansit" },
          { "ReasonId": 33, "Reason": "Manipulatation/Tampering by Coloader Staff" },
          { "ReasonId": 34, "Reason": "Theft By Coloader Staff" },
          { "ReasonId": 35, "Reason": "Vehicle Accident" },
        ],
        "Lost_by_local_transport": [
          { "ReasonId": 36, "Reason": "Damaged In Intransit" },
          { "ReasonId": 37, "Reason": "Lost Intansit" },
          { "ReasonId": 38, "Reason": "Manipulatation/Tampering by Coloader Staff" },
          { "ReasonId": 39, "Reason": "Theft By Coloader Staff" },
          { "ReasonId": 40, "Reason": "Vehicle Accident" },
        ]
      },
      form: {
        shippingidchk: [],
        values: [],
        checkboxval: []
      },
      isSearchLoading: false,
      srLoader: "",
      localhubdetails: '',
      defaultHhub: { hubID: '', HubName: '' },
      zone_obj: { hubzoneid: '', hubzonename: '' },
      hubinfo: {},
      totalRecords: 0,
      totalSelectedRecords: 0,
      clientArrayList: [],
      totalRecords: 0,
      value: 0,
      last_value: 0,
      validation: {
        min: 0,
        max: 10000000000000,
        decimal: 100
      },
      apiResponse: [],
      apiResponseforInvalid : [],
      modelValue: false,
      styleObjectFailure: {
        // 'background-color': 'red'
        'text-color': 'red',
        'color':'red'
      },
      styleObjectSuccess: {
        // 'background-color': 'green',
        'text-color': 'green',
        'color':'green'
      },
      shippingIdForMeta: [],
      dataObj: [],
      successData: [],
      errorData: [],
      awbnumbers: '',
      partialDebit : false,
      noRedirect : false,
      Success : '',
      apiResponseforTable : [],
      lostreason : [],
      checkbox : false,
      RSCPopUP : false,
      RSCShippingArr : [],
      NonRSCShippingArr : [],
      RSCShipmentList : [],
      NONRSCShipmentList : [],
      Vertical : ''
    }
  },
  created: function () {
  },
  filters: {
    flteramount: function(amount) {
      if (amount == null || amount == '' || amount == '0' || amount == 0)
        return '0.00';
      return amount;
    }
  },
  async mounted() {
    let validateUser = await this.validateJwtToken();
    this.getClientData();
    this.getHubZoneData();
    this.getHubServiceCenterData();
    this.getLostReasonData();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];

    this.hubinfo = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    this.defaultHhub.hubID = this.hubinfo.HubID
    this.defaultHhub.HubName = this.hubinfo.HubName
    this.zone_obj.hubzoneid = this.hubinfo.hubzoneid
    this.zone_obj.hubzonename = this.hubinfo.hubzonename
    this.hubname = this.hubinfo.HubID
  },
  methods: {
    calculateselectedcount() {
      this.totalSelectedRecords = this.form.shippingidchk.length
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        //alert("Form1 Submitted")
        if (result) {
          //scope.chkSelect = this.chkSelect.join(',');
          //scope.availability = this.availability.join(',');
          let temparr = [];
          let shipmentArr = [];
          this.apiResponse = [];
          this.apiResponseforTable = [];
          this.apiResponseforTable = [];
          if (this.form.shippingidchk.length == 0) {
            this.$alertify.error("Please select shipment(s)!");
          } else {
            this.isLoading = true;
            this.form.shippingidchk.forEach((item) => {
              // let tempArr = item.split('_');
              this.shippingIdForMeta = item.ShippingID.toString()
              let shipmentObj = {
                "ShippingID": item.ShippingID.toString(),
                "ClientID": parseInt(item.ClientID),
                "CurrentHubID": parseInt(item.CurrentHubId),
                "NetPayment": parseInt(item.NetPayment),
                "OctarioMRP": parseInt(item.OctroiMRP),
              };
              temparr.push(shipmentObj);
            });
            let payload = {
              Shipments: temparr,
              LostReason: this.ddlLostReasons,
              SubLostReason: this.ddlSubLostReason,
              LastModifiedBy: this.localusermailid
            };
            this.lostreason.push(this.ddlLostReasons,this.ddlSubLostReason)
            axios.post(apiUrl.api_url + 'NoInfoShipments/validateLostShipments', payload)
              .then((response) => {
                if (response.data.code == 200) {
                  let TrackerInfo = {
                    projectname: "Last Mile",
                    type: "Web",
                    userid: this.localuserid,
                    username: this.localusermailid,
                    meta: {
                      "event": "markShipmentLost",
                      "LostReason": this.ddlLostReasons,
                      "SubLostReason": this.ddlSubLostReason,
                      "shippingId": this.shippingIdForMeta
                    }
                  }
                  this.PageTracker(TrackerInfo);
                  if (response.data.message[0].promiseArr.length > 0 && response.data.message[1].LOSTMarkedShipments.length == 0) {
                    let successShippingId = []
                    response.data.message[0].promiseArr.map(obj => {
                      successShippingId.push(obj.ShippingID)
                    })
                    let shippingIds = JSON.stringify(successShippingId)
                    this.$router.push({
                      name: 'Hub Mark LostDebit',
                      path: '/HubMarkLostDebit',
                      query: { id: shippingIds,reason:this.lostreason },
                      component: 'HubMarkLostDebit'
                    });
                  } else if (response.data.message[0].promiseArr.length > 0 && response.data.message[1].LOSTMarkedShipments.length > 0) {
                    this.Success = response.data.message[0].promiseArr.length
                    let resPromiseArr = response.data.message[0].promiseArr
                    let resLOSTShipments = response.data.message[1].LOSTMarkedShipments
                    let count = 0
                    resPromiseArr.map(obj => {
                      this.apiResponse.push(obj)
                      count += 1
                    })

                    if(this.apiResponse.length == 1){
                      this.apiResponseforTable.push({
                        'ShippingID' : this.apiResponse[0].ShippingID,
                        'ReturnMessage': `${count} : Shipment validated successful`,
                        'ReturnCode': '100'
                      })
                    }
                    else if(this.apiResponse.length == 2){
                      this.apiResponseforTable.push({
                        'ShippingID' : this.apiResponse[0].ShippingID +","+ this.apiResponse[1].ShippingID ,
                        'ReturnMessage': `${count} : Shipments validated successful`,
                        'ReturnCode': '100'
                      })
                    }
                    else{
                      this.apiResponseforTable.push({
                        'ShippingID' : this.apiResponse[0].ShippingID +","+ this.apiResponse[1].ShippingID  + ","  +"....",
                        'ReturnMessage': `${count} : Shipments validated successful`,
                        'ReturnCode': '100'
                      })
                    }

                    resLOSTShipments.map(obj => {
                      this.apiResponse.push(obj)
                    })

                    resLOSTShipments.map(obj => {
                      this.apiResponseforTable.push(obj)
                    })
                    this.modelValue = true;
                    this.partialDebit = true
                  } else if (response.data.message[1].LOSTMarkedShipments.length > 0 && response.data.message[0].promiseArr.length == 0){
                    let resLOSTShipments = response.data.message[1].LOSTMarkedShipments
                    resLOSTShipments.map(obj => {
                      this.apiResponse.push(obj)
                    })
                    resLOSTShipments.map(obj => {
                      this.apiResponseforTable.push(obj)
                    })
                    this.modelValue = true
                    this.noRedirect = true
                  }
                }
                else if(response.data.code == 202){
                  this.RSCPopUP = true
                  this.RSCShippingArr = response.data.RSCShipment
                  this.NonRSCShippingArr = response.data.NonRSCShipment
                }
                else {
                  this.$alertify.error(response.data.message.promiseArr);
                }
                this.form.shippingidchk = [];
                this.clearAll();
                this.totalSelectedRecords = 0
                this.isLoading = false;
              }).catch((httpException) => {
                this.$alertify.error("No Records Found!");
                console.error('exception is:::::::::', httpException)
                this.isLoading = false;
              });
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    closeApprovalResultModel() {
      this.apiResponseforTable = []
      this.checkbox = false
      this.form.shippingidchk = []
      this.modelValue = false
      this.noRedirect = false
    },
    closeRSCValidationModel() {
      this.checkbox = false
      this.form.shippingidchk = []
      this.RSCPopUP = false
      this.noRedirect = false
    },
    partialRaiseDebit(){
      let partialRaiseDebit = []
      this.apiResponse.map(data => {
        if(data.ReturnCode == 100){
          partialRaiseDebit.push(data.ShippingID)
        }
      })
      let shippingIds = JSON.stringify(partialRaiseDebit)
      this.$router.push({
        name: 'Hub Mark LostDebit',
        path: '/HubMarkLostDebit',
        query: { id: shippingIds,reason:this.lostreason },
        component: 'HubMarkLostDebit'
      });
    },
    redirectHubMarkLostDebit(data) {
      this.$router.push('/LOST/HubMarkLostDebit.aspx?nsid=123');
    },

    getShipmentLogData(data) {
      this.$validator.reset();
      this.errors.clear();
      this.shipmentlogmodal = true;
    },

    closeShipmentLogModal() {
      this.shipmentlogmodal = false,
        this.$validator.reset();
      this.errors.clear();
    },

    getclientsObj(obj) {
      this.clientItemObj = obj
      this.clientid = obj.value
    },
    //to get Client list
    getClientData() {
      //  console.log('apiUrl.api_url',apiUrl.api_url);
      this.srLoader = this.loader;
      axios.get(apiUrl.api_url + 'external/getclientlist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.clientArrayList = response.data.data;
            for (let i = 0; i < this.clientArrayList.length; i++) {
              this.clientList.push({
                value: this.clientArrayList[i].ClientMasterID,
                text: `${this.clientArrayList[i].CompanyName}`
              })
            }
          }
          else {
            this.clientList = [];
          }
          this.srLoader = "";
        })
        .catch((httpException) => {
          this.$alertify.error("client data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    getHubListByZone(event) {
      axios.get(apiUrl.api_url + `external/getzonewisehublist?zoneid=` + event.target.value, {})
        .then((response) => {

          if (response.data.code === 200) {

            this.hubServiceCenterList = response.data.data;
            this.hubServiceCenterList.sort(function (a, b) {
              var nameA = a.HubName.toLowerCase(), nameB = b.HubName.toLowerCase()
              if (nameA < nameB) //sort string ascending
                return -1
              if (nameA > nameB)
                return 1
              return 0 //default return value (no sorting)
            });
          }
          else {
            this.hubServiceCenterList = [];
          }
        })
        .catch((httpException) => {
          //this.$alertify.error("Hub data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    getLostReasonData() {
      axios.get(apiUrl.api_url + `external/getreasons?reasonType=Lost`)
        .then((response) => {
          if (response.data.code === 200) {
            this.lostReasonsList = response.data.data;
          } else {
            this.lostReasonsList = [];
          }
          //console.log(lostReasonsList);
        })
        .catch((httpException) => {
          this.$alertify.error("Reason data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    getSubLostReasonData(event) {
      //console.log(event.target.value);
      switch (event.target.value) {
        case "Lost_By_SR":
          this.subLostReasonsList = this.optionsData.Lost_By_SR
          break;
        case "Lost_By_Staff":
          this.subLostReasonsList = this.optionsData.Lost_By_Staff
          break;
        case "Lost_By_Delivery_Agent":
          this.subLostReasonsList = this.optionsData.Lost_By_Delivery_Agent
          break;
        case "Dispute_Client_Consignee":
          this.subLostReasonsList = this.optionsData.Dispute_Client_Consignee
          break;
        case "Lost_by_coloader":
          this.subLostReasonsList = this.optionsData.Lost_by_coloader
          break;
        case "Lost_by_local_transport":
          this.subLostReasonsList = this.optionsData.Lost_by_local_transport
          break;
        default:
          this.subLostReasonsList = [];
      }
    },

    //to get Hub Zone list
    getHubZoneData() {
      axios.get(apiUrl.api_url + 'external/gethubzonelist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.hubZoneList = response.data.data;
          }
          else {
            this.hubZoneList = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.error("hubzone data not found");
          console.error('exception is:::::::::', httpException)
        })
    },

    //to get Hub Service Center list
    getHubServiceCenterData() {
      axios.get(apiUrl.api_url + 'external/gethublist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.hubServiceCenterList = response.data.data;
          }
          else {
            this.hubServiceCenterList = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.error("Hub data not found");
          console.error('exception is:::::::::', httpException)
        })

    },

    //to get pagination
    getPaginationData(pageNum) {
      this.checkbox = false
      // this.totalSelectedRecords = 0
      // this.form.shippingidchk = [];
      this.pageno = pageNum;
      this.searchLostShipmentData();
    },
    searchData() {
      this.pageno = 1
      this.$refs.paginate.selected = 0;
      this.searchLostShipmentData();
    },

    //search Raise Debit data
    searchLostShipmentData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.hubname != 0) {
            let payload = {};
            this.isSearchLoading = true;
            if (this.awbnumbers.length > 0) {
              let shippingIds = this.awbnumbers.split(/[\s,]+/).filter(shipmentId => shipmentId.trim() !== '');
              payload.ShippingId = shippingIds;
            }
            if (this.Vertical != 0) payload.Vertical = this.Vertical;
            if (this.clientid != 0) payload.ClientID = this.clientid;
            if (this.listtype != 0) payload.ListType = this.listtype;
            if (this.hubzone != 0) payload.CurrentHubZoneID = this.hubzone;
            if (this.hubname != 0) payload.CurrentHubId = this.hubname;
            if (this.notifystatus != 0) payload.NotifyStatus = this.notifystatus;
            if (this.amount != 0) payload.Amount = this.amount + '/' + this.amountcomparator + '/' + this.netpaymnet;
            if (this.gapdays != 0) payload.GapDays = this.gapdays + '/' + this.gapdayscomparator + '/' + this.txtgapdays;
            payload.pageNo = this.pageno;
            payload.pageSize = 50;
            //console.log(payload);4
            axios.post(apiUrl.api_url + 'NoInfoShipments/list', payload)
              .then((response) => {
                if (response.data.code == 200) {
                  let shipmentListData = response.data.data.rows;
                  //  console.log(shipmentListData);
                  let temparr = [];
                  let temparrCSV = [];
                  if (shipmentListData != null) {
                    response.data.data.rows.forEach((shipment) => {
                      shipment.NetPayment = shipment.NetPayment != null ? shipment.NetPayment : "0.00"
                      shipment.OctroiMRP = shipment.OctroiMRP != null ? shipment.OctroiMRP : "0.00"
                      var newcreateddate = this.changeDateFormat(shipment.CreatedDate);
                      var checkboxval = shipment.ShippingID + '_' + shipment.ClientID + '_' + shipment.CurrentHubId + '_' + shipment.NetPayment + '_' + shipment.OctroiMRP
                      shipment.CreatedDate = newcreateddate;
                      shipment.checkboxval = checkboxval.toString();
                      temparrCSV.push({
                        "ClientName": shipment.ClientName,
                        "ShippingID": shipment.ShippingID,
                        "NetPayment": shipment.NetPayment,
                        "OctroiMRP": shipment.OctroiMRP,
                        "NotifyStatus": shipment.NotifyStatus,
                        "Status": shipment.Status,
                        "ShipmentStatus": shipment.ShipmentStatus,
                        "CurrentHubName": shipment.CurrentHubName,
                        "OriginHubName": shipment.OriginHubName,
                        "FinalDestinationName": shipment.FinalDestinationName,
                        "NotifyGapDays": shipment.NotifyGapDays,
                        "ShipmentGapDays": shipment.ShipmentGapDays,
                        "CreatedDate": newcreateddate,
                        "CreatedBy": shipment.CreatedBy,
                      });
                    });
                  }
                  this.shipmentList = response.data.data.rows;
                  this.shipmentListCSV = temparrCSV;

                  let totalRows = response.data.TotalCount;
                  this.totalRecords = response.data.TotalCount
                  this.isShowing = true;
                  if (totalRows < 50) {
                    this.pagecount = 1
                  } else {
                    this.pagecount = Math.ceil(totalRows / 50)
                  }
                } else {
                  this.shipmentList = [];
                  this.$alertify.error("No Records Found!");
                }
                this.isSearchLoading = false;
                //console.log('shipmentList',this.shipmentList);
              })
              .catch((httpException) => {
                this.$alertify.error("No Records Found!");
                console.error('exception is:::::::::', httpException)
                this.isSearchLoading = false;
              });
          }
        }
      }).catch(() => {
        this.isSearchLoading = false;
        console.log('errors exist', this.errors)
      });
    },
    onSubmit: function (event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.searchRaiseDebitData(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async exportForm() {
      if (this.shipmentListCSV == undefined || this.shipmentListCSV.length == 0) {
        this.$alertify.alert("No data", "No data available for download.");
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          let payload = {};
          this.isSearchLoading = true;
          if (this.clientid != 0) payload.ClientID = this.clientid;
          if (this.listtype != 0) payload.ListType = this.listtype;
          if (this.hubzone != 0) payload.CurrentHubZoneID = this.hubzone;
          if (this.hubname != 0) payload.CurrentHubId = this.hubname;
          if (this.notifystatus != 0) payload.NotifyStatus = this.notifystatus;
          if (this.amount != 0) payload.Amount = this.amount + '/' + this.amountcomparator + '/' + this.netpaymnet;
          if (this.gapdays != 0) payload.GapDays = this.gapdays + '/' + this.gapdayscomparator + '/' + this.txtgapdays;
          payload.pageNo = this.pageno;
          payload.pageSize = 10;
          payload.exportFlag = "1"
          axios.post(apiUrl.api_url + 'NoInfoShipments/list', payload)
            .then((response) => {
              if (response.data.code == 200) {
                let shipmentListData = response.data.data.rows;
                let temparrCSV = [];
                if (shipmentListData != null) {
                  response.data.data.rows.forEach((shipment) => {
                    var newcreateddate = this.changeDateFormat(shipment.CreatedDate);
                    var checkboxval = shipment.ShippingID + '_' + shipment.ClientID + '_' + shipment.CurrentHubId
                    shipment.CreatedDate = newcreateddate;
                    shipment.checkboxval = checkboxval.toString();
                    temparrCSV.push({
                      "ClientName": shipment.ClientName,
                      "ShippingID": shipment.ShippingID,
                      "NetPayment": shipment.NetPayment,
                      "OctroiMRP": shipment.OctroiMRP,
                      "NotifyStatus": shipment.NotifyStatus,
                      "Status": shipment.Status,
                      "ShipmentStatus": shipment.ShipmentStatus,
                      "CurrentHubName": shipment.CurrentHubName,
                      "OriginHubName": shipment.OriginHubName,
                      "FinalDestinationName": shipment.FinalDestinationName,
                      "NotifyGapDays": shipment.NotifyGapDays,
                      "ShipmentGapDays": shipment.ShipmentGapDays,
                      "CreatedDate": newcreateddate,
                      "CreatedBy": shipment.CreatedBy,
                    });
                  });
                }
                this.shipmentListCSV = temparrCSV;
                this.getDownloadCsvObject(this.shipmentListCSV);

              } else {
                this.shipmentList = [];
                this.$alertify.error("No Records Found!");
              }
              this.isSearchLoading = false;
              this.getDownloadCsvObject(this.shipmentListCSV);
              //console.log('shipmentList',this.shipmentList);
            })
            .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
              this.isSearchLoading = false;
            });
        }
      }).catch(() => {
        this.isSearchLoading = false;
        console.log('errors exist', this.errors)
      });
      //await this.searchLostShipmentData()

    },
    changeDateFormat(inputString) {
      let current_datetime = new Date(inputString)
      let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
      return formatted_date;
    },
    getDownloadCsvObject(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MarkLostShipment_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function (item) {
        ctr = 0;
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
    },
    resetForm() {
      this.Vertical = '';
      this.awbnumbers = []
      this.clientid = 0;
      this.clientItemObj = {}
      this.listtype = 'ServiceCenter'
      // this.hubzone = 0;
      // this.hubname = 0;
      this.amount = 0;
      this.amountcomparator = 0;
      this.netpaymnet = '';
      this.gapdays = 0;
      this.txtgapdays = '';
      this.gapdayscomparator = 0;
      this.pageno = 1;
      this.$refs.paginate.selected = 0;
      this.isShowing = false;
      this.ddlLostReasons = '';
      this.ddlSubLostReason = '';
      this.form.shippingidchk = []
      document.getElementById('checkbox1').checked = false;
      this.$validator.reset();
      this.errors.clear();
      this.defaultHhub.hubID = this.hubinfo.HubID
      this.defaultHhub.HubName = this.hubinfo.HubName
      this.zone_obj.hubzoneid = this.hubinfo.hubzoneid
      this.zone_obj.hubzonename = this.hubinfo.hubzonename
      this.hubname = this.hubinfo.HubID
    },
    clearAll() {
      this.ddlLostReasons = '';
      this.ddlSubLostReason = '';
      document.getElementById('checkbox1').checked = false;
      this.$validator.reset();
      this.errors.clear();
      this.totalSelectedRecords = 0
    },
    format_number(e) {
      if (e > this.validation.max) {
        return this.validation.max
      } else if (e < this.validation.min) {
        return this.validation.min
      } else if (Math.round(e * this.validation.decimal) / this.validation.decimal != e) {
        return this.last_value
      } else {
        this.last_value = e
        return e
      }
    },
    selectItems(ev) {
      this.form.shippingidchk = [];
      if (ev.target.checked == true) {
        this.shipmentList.map(obj => {
          this.form.shippingidchk.push(obj)
        })
      } else {
        this.shipmentList.map(obj => {
          this.form.shippingidchk.pop(obj)
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/MarkLostShipment/MarkLostShipment.component.js